import React, { useState } from 'react';
import { FaBug, FaPaperclip, FaUpload } from 'react-icons/fa';

const ReportBug = () => {

    const [description, setDescription] = useState('');
    const [file, setFile] = useState(null);



    const handleSubmit = async (e) => {

        const user_id = JSON.parse(sessionStorage.getItem('user'));
        if (!user_id || !user_id.id) {
            console.error('User not logged in');
            return;
        }

        e.preventDefault();
        const formData = new FormData();
        formData.append('description', description);
        formData.append('file', file);
        formData.append('user_id', user_id.id);

        try {
            const response = await fetch('https://botapi.emedha.in/pages/api/api/report-bug', {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (response.ok) {
                alert('✅ Thank you for your report. We will get back to you shortly.');
                setDescription('');
                setFile(null);
            } else {
                alert(`Failed to submit bug: ${data.error}`);
            }
        } catch (error) {
            console.error('Error submitting bug:', error);
            alert('An error occurred while submitting the bug.');
        }
    };


    return (
        <div style={{ margin: '50px auto', padding: '30px', backgroundColor: '#ffffff', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)', fontFamily: 'Segoe UI, sans-serif', }}>
            <h2 style={{ fontSize: '24px', marginBottom: '20px', display: 'flex', alignItems: 'center', color: '#2c3e50', }}>
                <FaBug style={{ marginRight: '10px', color: '#e74c3c' }} /> Report a Bug
            </h2>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px', }}>
                <div style={{ display: 'flex', flexDirection: 'column', }}>
                    <label style={{ fontWeight: '600', marginBottom: '8px', color: '#34495e', }}>Bug Description:</label>
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Describe the issue in detail..."
                        rows={5}
                        style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ccc', resize: 'vertical', fontSize: '14px', }}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', }}>
                    <label style={{ fontWeight: '600', marginBottom: '8px', color: '#34495e', }}>
                        <FaPaperclip style={{ marginRight: '8px', color: '#8e44ad', }} /> Attach Screenshot / File:
                    </label>
                    <input
                        type="file"
                        onChange={(e) => setFile(e.target.files[0])}
                        style={{ padding: '8px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '14px', }}
                    />
                </div>
                <button type="submit" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '12px 20px', backgroundColor: '#3498db', color: '#fff', fontSize: '16px', fontWeight: 'bold', border: 'none', borderRadius: '8px', cursor: 'pointer', transition: 'background-color 0.3s ease', }}>
                    <FaUpload style={{ marginRight: '8px', }} /> Submit Bug
                </button>
            </form>
        </div>
    );
};


export default ReportBug;
